// src/config.js

// 1. Look for the environment variable.
// 2. If not found (e.g., in local dev without a .env file), fallback to localhost.
// 3. Remove any trailing slash to prevent double slashes (e.g., http://api.com//api)
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/$/, '');

export default API_BASE_URL;